import {createConfig as createBestReviewsConfig} from '../bestreviews/config'

const localeConfigs = {
  us: {
    measurementId: 'G-J6ZKH0SHSY',
  },
}

export const createConfig = (locale: string = 'us') => {
  const normalizedLocale = locale.toLowerCase()
  const bestReviewsConfig = createBestReviewsConfig(normalizedLocale)
  const localeConfig = localeConfigs[normalizedLocale as keyof typeof localeConfigs] || {}

  return {
    ...bestReviewsConfig,
    ...localeConfig,
  }
}
